


















import Vue from "vue";
import Component from "vue-class-component";
import XFeather from './feather.vue';
const feather = require("feather-icons");

export interface IMenu {
  name: string;
  icon: string;
  route: string;
  caption: string;
  isVisable: boolean;
  children: Array<IMenu>;
}

@Component({
  name: "nodes",
  props: ["menu"],
  components: {
    'xfeather' : XFeather,
  }
})
export default class Nodes extends Vue {
  menu: IMenu = {name: '', icon: '', route: '', caption: '', isVisable: true, children: []};
  isActive: boolean = false;
  icon: string = "";

  mounted() {
    if (this.menu) {
      if (feather.icons) {
        if (feather.icons[this.menu.icon]) {
          this.icon = feather.icons[this.menu.icon].toSvg({
            class: "sidebar-icon",
            "stroke-width": 2
          });
        }
      }
    }
  }

  subIsActive() {
    return true;
  }
}
